import * as SheetPrimitive from "@radix-ui/react-dialog";
import { FC } from "react";

import {
  SHEET_HEADER_TEXT_CLASS,
  SHEET_ROOT_DEFAULTS,
  TSheetRootProps,
} from "./Sheet.config";
import { SheetContent } from "./SheetContent";
import { SheetHeader } from "./SheetHeader";
import { SheetTitle } from "./SheetTitle";
import { SheetDescription } from "./SheetDescription";
import { SheetChildren } from "./SheetChildren";
import { SheetFooter } from "./SheetFooter";
import { SheetBack } from "./SheetBack";

export const Sheet: FC<TSheetRootProps> = (
  {
    title,
    description,
    children,
    footer,
    align,
    side = SHEET_ROOT_DEFAULTS.side,
    surface = SHEET_ROOT_DEFAULTS.surface,
    onBack,
    backLabel,
    hideDescription,
    close,
    returnFocusRef,
    contentClassName,
    ...props
  },
) => (
  <SheetPrimitive.Root {...props}>
    <SheetContent
      side={side}
      surface={surface}
      close={close}
      onCloseAutoFocus={(event) => {
        if (returnFocusRef?.current) {
          event.preventDefault();
          returnFocusRef.current.focus();
        }
      }}
      className={contentClassName}
    >
      <SheetHeader>
        { onBack ? <SheetBack aria-label={backLabel} onClick={onBack} /> : null }
        <div className={SHEET_HEADER_TEXT_CLASS}>
          <SheetTitle align={align}>{ title }</SheetTitle>
          <SheetDescription align={align} hideDescription={hideDescription}>
            { description }
          </SheetDescription>
        </div>
      </SheetHeader>
      <SheetChildren>
        { children }
      </SheetChildren>
      <SheetFooter {...footer} align={align} />
    </SheetContent>
  </SheetPrimitive.Root>
);
